import { Col, Row } from "react-bootstrap";

import { parseDate } from "../../common/Utilities";
import { PALETTE } from "../../common/ThemeConstants";

export default function CardPurchase({ img, title, startDate, expireDate }) {
  const today = new Date();
  const expire = new Date(expireDate);
  const isActive = today < expire;
  return (
    <div className="rounded-md shadow-sm py-1">
      <Row>
        <Col xs={2} className="text-start align-self-center">
          <img src={img} alt={title} style={{ width: 35, height: 35 }} />
        </Col>
        <Col xs={7} className="text-start align-self-center">
          <p className="cardDescription" style={{ marginBottom: "2px" }}>
            {" "}
            {title}
          </p>
          <span className="cardDescription" style={{ color: PALETTE.GRAY }}>
            Inizio: {parseDate(startDate)}
          </span>
          <br />
          <span className="cardDescription" style={{ color: PALETTE.GRAY }}>
            Scadenza: {parseDate(expireDate)}
          </span>
        </Col>
        <Col xs={3} className="text-center align-self-center">
          {isActive ? (
            <span style={{ color: PALETTE.GREEN2 }}>Attivo</span>
          ) : (
            <span style={{ color: PALETTE.RED2 }}>Scaduto</span>
          )}
        </Col>
      </Row>
    </div>
  );
}
